import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Navigate } from "react-router";
import Login from "../components/user/Login";
import appStyles from "../styles/appStyles";
import { withStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import AuthService from '../service/AuthService';
import { ThemeProvider } from '@mui/material/styles';
import DashBoard from '../components/DashBoard/Dashboard';
import PrivateRoute from "./PrivateRoute"
import DHSPolicy from '../components/other/DHSPolicy';
import Register from '../components/user/Register';
import ForgotPassword from '../components/user/ForgotPassword';
import ManagerUsers from '../components/managerUsers/ManagerUsers';
import ManageProjects from '../components/projects/ManageProjects';
function renderComponent(Component, defaultProps, customProps) {
    let props = { ...defaultProps, ...customProps }
    let StyledComponent = withStyles(appStyles)(Component);
    return <StyledComponent {...props} />
}

const PrivateRoute1 = ({ element: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            element={AuthService.getUserInfo() != null ? <Component /> : <Navigate to="/login" />}
        />
    );
};

const AppRoutes = () => {
    const location = useLocation();

    const [userInfo, setUserInfo] = useState(null);
    useEffect(() => {
        setUserInfo(AuthService.getUserInfo());
    }, []);
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/policy" element={<DHSPolicy />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/managerUsers" element={<ManagerUsers />} />
            <Route path="/manageProjects" element={<ManageProjects />} />

        </Routes>
    );
}






export default AppRoutes;